import React, { useState } from 'react';
import { useIntl } from 'umi';
import { Bubble, Icon } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';
import { copyTextToClipboard } from '@/pages/datalab/utils/utils';

const MCP_SSE_PATH = '/mcp/cube/sse';

const McpAddressHeader = () => {
  const { formatMessage } = useIntl();
  const [contentId, setContentId] = useState('');
  const mcpAddress = `${window.location.origin}${MCP_SSE_PATH}`;

  const content = contentId === 'dbl_common_copy_success'
    ? (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Icon type="success" style={{ marginRight: '4px' }} />
        {formatMessage({ id: contentId })}
      </div>
    )
    : (contentId && formatMessage({ id: contentId }));

  return (
    <div className="dbl-model-management-title">
      {formatMessage({ id: "dbl_model_management_title" })}
      <div className="dbl-model-management-mcp">
        <span className="dbl-model-management-mcp-label">
          {formatMessage({ id: "dbl_model_management_mcp_address" })}:
        </span>
        <span className="dbl-model-management-mcp-link">
          {mcpAddress}
        </span>
        <Bubble content={content} dark>
          <span
            onMouseEnter={() => setContentId('dbl_common_copy')}
            onMouseLeave={() => setContentId('')}
          >
            <SvgIcon
              type="copy-new"
              className="dbl-model-management-mcp-copy"
              onClick={() => {
                copyTextToClipboard(mcpAddress)?.then(() => {
                  setContentId('dbl_common_copy_success');
                }, (err) => {
                  console.error('MCP 链接复制错误: ', err);
                  setContentId('dbl_common_copy_error');
                });
              }}
            />
          </span>
        </Bubble>
      </div>
    </div>
  );
};

export default McpAddressHeader;
